import { defineComponent } from 'vue';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';

import { OPEN_AUDIT_CAMPAIGN_POP_UP } from '../../../../busTopics';
import { ItemEditMenu } from '@skinsoft/entity-ui/src/item/components/item-edit-menu'
import { TOGGLE_MENU_TOPIC } from '@skinsoft/bus/src/busTopics';

export const AuditItemEditMenu = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sItemEditMenu: ItemEditMenu
    },
    props: [''],
    template: require('./audit-item-edit-menu.html'),
    methods: {
        openCampaignPopUp() {
            this.emitOnBus(OPEN_AUDIT_CAMPAIGN_POP_UP)
            this.emitOnBus(TOGGLE_MENU_TOPIC)
        },
    },
})
